import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BackGroundCheckGateway } from './background-check-gateway'
import { BackGroundCheck } from '../models/background-check'

@Injectable()
export class NetworkBackGroundCheckGateway extends BackGroundCheckGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getBackGroundCheckData(): Observable<BackGroundCheck[]> {
        return this.http.get<BackGroundCheck[]>('..api/getBackgroundDetails')
    }
}
